const VIEWPORT_PADDING = 8
const ANCHOR_GAP = 4
const MIN_POPUP_WIDTH = 230
const MAX_POPUP_WIDTH = 300
const ANCHOR_WIDTH_OFFSET = 150

const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

export const calculateColumnValueFilterPosition = ({
  anchorRect,
  popupHeight,
  viewportWidth,
  viewportHeight
}) => {
  const availableViewportWidth = Math.max(
    0,
    viewportWidth - VIEWPORT_PADDING * 2
  )
  const preferredWidth = Math.max(
    MIN_POPUP_WIDTH,
    Math.min(MAX_POPUP_WIDTH, anchorRect.width + ANCHOR_WIDTH_OFFSET)
  )
  const width = Math.min(preferredWidth, availableViewportWidth)
  const maxLeft = Math.max(
    VIEWPORT_PADDING,
    viewportWidth - VIEWPORT_PADDING - width
  )
  const left = clamp(anchorRect.left, VIEWPORT_PADDING, maxLeft)

  const availableBelow = Math.max(
    0,
    viewportHeight - anchorRect.bottom - ANCHOR_GAP - VIEWPORT_PADDING
  )
  const availableAbove = Math.max(
    0,
    anchorRect.top - ANCHOR_GAP - VIEWPORT_PADDING
  )
  const placement =
    popupHeight > availableBelow && availableAbove > availableBelow
      ? 'top'
      : 'bottom'
  const maxHeight = placement === 'top' ? availableAbove : availableBelow

  return {
    placement,
    style: {
      top:
        placement === 'bottom'
          ? clamp(
              anchorRect.bottom + ANCHOR_GAP,
              VIEWPORT_PADDING,
              Math.max(VIEWPORT_PADDING, viewportHeight - VIEWPORT_PADDING)
            )
          : 'auto',
      bottom:
        placement === 'top'
          ? clamp(
              viewportHeight - anchorRect.top + ANCHOR_GAP,
              VIEWPORT_PADDING,
              Math.max(VIEWPORT_PADDING, viewportHeight - VIEWPORT_PADDING)
            )
          : 'auto',
      left,
      width,
      maxHeight
    }
  }
}
